import {svgjs} from 'svg.js';

import {Init} from 'core/Init';
import {Calc} from 'core/util/Calc';
import {Params} from 'core/services/Params';

import {Hitpoint} from 'core/items/Hitpoint';
import {Attachable} from 'core/items/base/Attachable';
import {Parent} from 'core/items/base/Parent';
import {APP_EVT} from 'core/config/constants';
import {Rules} from 'core/main/Rules';
import {Target} from 'core/main/Interface';


class Placement {

	public static params: Params;


	constructor() {

		Init.emitter.on(APP_EVT.ITEM_ACTIVE, this.showPossiblePlacements);

	}

m
	/**
	 * used to calculate collisions between existing accessories and our 'active item'.
	 * if a collision is detected, that hitpoint is deactivated.
	 *
	 * @param {Attachable} item
	 */
	showPossiblePlacements = (item: Attachable): void => {

		let rules: Rules = Init.line.rules;

		//console.log(item);

		//get the possible targets for our item
		let targets = Params.getTargets(item.itemId);

		if (!targets || targets.length == 0) return;

		Init.emitter.emit(APP_EVT.SHOW_BOX, ['_xbox', '_ybox', '_tbox']);

		item.setOpacity(0.5);

		let origin: svgjs.Matrix = item.ctm;

		//console.log(Init.set_design.items);
		// loop through all of our onstage items to find possible parents
		for (let [prntSvgId, prnts] of Init.set_design.items) {

			// is this item a possible parent?
			if (targets && targets[prnts.itemId] && prntSvgId != item.svgId) {

				let prnt: Parent = prnts as Parent;

				//console.log(prnt);

				prnt.resetHitpoints();

				// this prnt is a potential parent. let's loop through all the hitpoints
				// and find out if we have any collisions with existing accessories

				for (let hp_id of targets[prnt.itemId].hitpoints) {

					let hit: Target = item.getHitpointSegments(hp_id);

					//console.log('getHitpointSegments', hp_id, hit, hit.level, Init.active_level);

					let hp: Hitpoint = prnt.placeHitpoint(hit.hitpoint, 'hitpoint-bay-' + item.hitpointShape);
					//return;
					if (item.getParentHitpointConditional(prnt, hp) === false) {

						//console.log('getParentHitpointConditional', hp, prnt);
						prnt.invalidateHitpoint(hp_id);
						continue;
					}

					// if the item we are trying to place is not allowed in the level we are currently editing
					// invalidate this hitpoint and move on to the next parent.
					if (hit.level != null && hit.level != Init.active_level) {

						//console.log('hitlevel', hit.level, Init.active_level);
						prnt.invalidateHitpoint(hp_id);
						continue;
					}

					// if the level of the item we are trying to place does not match the available
					// level of the parent, invalidate the hitpoint and move on to the next parent.
					//console.log('itemLevel', item.itemLevel, prnt.itemLevel);
					if (item.itemLevel != prnt.itemLevel && item.itemLevel != null) {

						//console.log('itemLevel', item.itemLevel, prnt.itemLevel);
						prnt.invalidateHitpoint(hp_id);
						continue;
					}

					if (rules.testHeightLegality(item, prnt, hp_id) !== true) {

						//console.log('level', item.itemName, prnt.itemName, hp_id);
						prnt.invalidateHitpoint(hp_id);
						continue;
					}


					item.setItemLocation(hp);

					//console.log('hitlevel',  hit, hit.level, Init.active_level);

					for (let [chldSvgId, chld] of Init.set_design.items) {

						// make sure we are not checking an item against itself
						if (item.svgId != chldSvgId && prntSvgId != chldSvgId) {

							// let's exclude items on a different level, unless they specifically
							// need to check over/under items like fence etc
							// console.log(Init.active_level, chld.itemLevel);
							// test if we are editing the ground level OR we are editing the above-ground level:
							let child_hitpoint_location: string = chld.getPrntFirstHitpoint(prntSvgId);
							let this_hitpoint_location: string = hit.location;

							// hitpoint x/y is the same, see if the child and item can be stacked.
							//console.log(hit, child_hitpoint_location == this_hitpoint_location);
							if (child_hitpoint_location == this_hitpoint_location) {

								//console.log('1', hit, item.itemName , chld.itemName, child_hitpoint_location);
								rules.testStackedHitpoint(item, prnt, chld, hit, hp_id);

							} else {

								//console.log('1', hit, item.itemName , chld.itemName);

								// @TODO THIS block will need to be moved out to config

								if (item.collisionInclude === true && chld.collisionInclude === true) {

									//console.log('1', hit, item.itemName , chld.itemName);
									let child_bbox: svgjs.Element = (chld.xbox != null) ? chld.xbox : chld.ybox;

									// this one is for connectors. it will allow us to block connectors that
									// require ground stabilizers from being around the corner from crows nests.
									// this combination is not allowed as their parts conflict.
									if (rules.testSeriesItems) {

										if (rules.testSeriesItems(item, prnt, chld) === false) {

											prnt.invalidateHitpoint(hp_id);
											//console.log('1', hit, item.itemName , chld.itemName);
										}
										item.hideBounds(['_sbox']);
									}

									// xbox is an SVG rect that allows us to test for neighbors; ybox is a rect that allows
									// us to test for playspace extending out from the accessory

									let item_bbox: svgjs.Element = (item.xbox != null) ? item.xbox : item.ybox;
									//console.log(item.itemName, item.xbox, chld.itemName, chld.xbox);
									// check bbox overlap first as it's fast. If we have an overlap then we can safely skip
									// the more intensive step of testing for svg stroke overlap.

									if (Calc.noOverlap(child_bbox.rbox(), item_bbox.rbox()) === true) {
										//console.log('1', hit, child_bbox.rbox(), item_bbox.rbox());
										//console.log('1', hit, item.itemName , chld.itemName);
										// using a stroke-intersect routine to find out if polygons intersect, rather than
										// pixel-to-pixel detection which is much more intensive.
										let intersect: boolean = Calc.getPolygonIntersect(chld, item);

										if (intersect === true) {
											//console.log(item, chld, Calc.noOverlap(child_bbox, item_bbox));
											// we have found a collision, so remove this hitpoint
											// from our list of potential placement options
											prnt.invalidateHitpoint(hp_id);
											//console.log('1', hit, item.itemName , chld.itemName);
										}

									} else {

										//console.log('2', hit, item.svgId, chld.svgId);
										if (rules.testNeighbor(chld.itemId, item.itemId) === false) {

											//console.log('2', hit, item.svgId, chld.svgId);
											//console.log('2', hit, item.itemName, chld.itemName, item_bbox, child_bbox);
											prnt.invalidateHitpoint(hp_id);

										}
										if (Math.abs(chld.r % 90) == 45 || Math.abs(item.r % 90) == 45) {

											prnt.invalidateHitpoint(hp_id);
										}
									}
								}
							}
						}
					}
				}
			}
		}

		// this call will not only hide the boxes but should reactivate the clickclip if disabled
		Init.emitter.emit(APP_EVT.HIDE_BOX, ['_xbox', '_ybox', '_tbox', '_sbox']);

		item.setToMatrix(origin);

	};

}

export {Placement};

